import { useState } from 'react';
import {
	Meta,
	useLazyWorkplaceMemberMetaQuery,
} from '../../../graphql/graphql';
import { useEffectAsync } from '../../../helpers';
import apiClient from '../../../Services/ApiClient';

export default function useWorkplaceMemberMeta(
	userId: string,
	workplaceId: string,
) {
	const [getMeta] = useLazyWorkplaceMemberMetaQuery();
	const [meta, setMeta] = useState<any>();
	const [isLoading, setIsLoading] = useState(false);

	useEffectAsync(async () => {
		await handleLoadMeta();
	}, []);

	const handleLoadMeta = async () => {
		setIsLoading(true);
		const data = await getMeta({ userId, workplaceId }).unwrap();
		if (data) {
			setMeta({ data: data });
		}
		setIsLoading(false);
	};

	const saveToMeta = async ({ key, value }: { key: string; value: any }) => {
		await apiClient.post(`/user/${userId}/meta/`, {
			key,
			value,
			workplaceId,
		});
	};

	return {
		reFetchMeta: () => handleLoadMeta(),
		workplaceMemberMeta: meta?.data?.workplaceMember?.meta as Meta[],
		workplaceMemberMetaIsLoading: isLoading,
		saveToWorkplaceMemberMeta: saveToMeta,
	};
}
